<div *ngIf="loading$ | async"
    class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-80 z-50 pointer-events-auto">
    <div class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"></div>
</div>